import React, {Component} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Button, Card, Input, Select, Tooltip} from 'antd'
import styles from './styles.less'
import Request, {API_URL} from '../../request'
import {TableComp} from 'sz-react-utils'
import {connect} from 'react-redux'

const {Option} = Select


class LibraryReport extends Component {

    apiRequest = params => {

        return new Promise(async resolve => {
            let searchParams = new URLSearchParams(this.props.search)
            let {searchvalueId, description, type, searchByQueryString} = this.state
            let universityId = searchParams.get('universityId')

            if (universityId && !searchByQueryString) {
                params.searchvalueId = universityId
                params.type = "university"
                this.state.type = "university"
                this.state.searchByQueryString = true;
            } else {
                params.type = type
                params.searchvalueId = searchvalueId
                params.description = description
            }

            let data = await Request.getLibraryReport({
                ...params

            })

            this.setState({total: data.total})
            resolve(data)
        })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.state = {
            loading: false,
            total: 0,
            searchvalueId: undefined,
            description: '',
            type: 'student',
            searchLoading: false,
            arr: [],
            searchByQueryString: false,
        }
    }

    componentDidMount() {
    }

    render() {

        const { filteredData, type, total} = this.state

        const columns = [
            {
                title: 'Description',
                key: 'description',
                render: (val, record) => {
                    return (
                        <div>
                            <div>{record && record.description}</div>
                            <small>{record && record.file ? record.file.name : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Details',
                key: 'details',
                render: (val, record) => {
                    return (
                        <div>{record && record.name} <span>{`(id:${record.id})`}</span></div>
                    )
                }
            },
            {
                title: 'Type',
                key: 'type'
            },

            {
                title: 'Download or View',
                key: 'operation',
                render: (val, record) => {
                    return (<React.Fragment>
                        <Tooltip title={'Download/View'}>
                            <Button
                                className={styles.btn}
                                size={'small'}
                                shape="circle"
                                style={{
                                    marginLeft: '3px',
                                    border: '1px solid #85CF4A'
                                }}
                                icon="download"
                                onClick={() => {
                                    window.open(
                                        `${API_URL}${record.file.url}`,
                                        '_blank'
                                    )

                                }}/></Tooltip>
                    </React.Fragment>)
                }
            }
        ]

        return (
            <PageHeaderWrapper title={`Library Report: ${total}`}>
                <Card style={{marginBottom: 10}}>
                    <Input placeholder={'Search description'} style={{width: 300, marginRight: '10px'}}
                           value={this.state.description}
                           onChange={(e) => {
                               this.setState({description: e.target.value})
                           }}/>

                    <Select
                        value={this.state.type}
                        placeholder="Select Student/University/Course/Country"
                        style={{
                            width: 300,
                            marginRight: '10px'
                        }}
                        onChange={async (v)  => {
                            this.setState({type: v, searchvalueId: '', description: '', filteredData: [],  searchLoading: true})
                
                            if( v === 'country'){
                                let {data} = await Request.searchData({test:'', type:v});
                                this.setState({filteredData: data, searchLoading: false})
                            }
                            
                        }}>
                        <Option value={'student'}>{'Student'}</Option>
                        <Option value={'university'}>{'University'}</Option>
                        <Option value={'course'}>{'Course'}</Option>
                        <Option value={'country'}>{'Country'}</Option>
                    </Select>

                    <Select
                        showSearch
                        allowClear
                        style={{
                            width: 300,
                            marginRight: '10px'
                        }}
                        value={this.state.searchvalueId}
                        placeholder={'Search'}
                        filterOption={type !== 'country' ? false : (input, option) => {
                            return (
                                option.props.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            );
                        }}
                        onSearch={async (test) => {
                            if( type !== 'country'){
                                this.setState({
                                    searchLoading: true
                                })
                                let {data} = await Request.searchData({test, type})
                                this.setState({filteredData: data, searchLoading: false})
                            }
                           
                        }}
                        onChange={id => {
                            this.setState({searchvalueId: id, arr: []}, () => {
                                console.log('e')
                            })
                        }}
                    >
                        {filteredData &&
                            filteredData.map((val, idn) => {
                                return (
                                    <Option key={idn} value={val.value}>{`${val.text} (id:${val.id})`}</Option>
                                )
                            })}
                    </Select>

                    <Button type={'primary'} onClick={() => {
                        this.table.current.reload()
                    }}>Search</Button>
                </Card>

                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        rowKey={(item, x) => {
                            return x
                        }}
                        id={'libraryReport'}
                        ref={this.table}
                        loading={this.state.loading}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LibraryReport)
